import RoleDetails from "./RoleDetails";

export default RoleDetails;
